module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.28.0-f3d742a11.svg#cart-v2-large","viewBox":"0 0 26 26"}